import Keycloak from "keycloak-js";



// Для production URL будет заменён через переменные окружения в Docker
let keycloakUrl = "https://test.ai-novation.online/oauth";
//let keycloakUrl = "http://localhost:9090";
let keycloakRealm = "rag";
let keycloakClientId = "ragapp";

if (typeof window !== 'undefined' && window.APP_CONFIG && window.APP_CONFIG.KEYCLOAK_URL && window.APP_CONFIG.KEYCLOAK_REALM && window.APP_CONFIG.KEYCLOAK_CLIENT_ID) {
  const configKeycloakUrl = window.APP_CONFIG.KEYCLOAK_URL;
  if (configKeycloakUrl !== "__KEYCLOAK_URL__") {
    keycloakUrl = window.APP_CONFIG.KEYCLOAK_URL;
  }

  const configKeycloakRealm = window.APP_CONFIG.KEYCLOAK_REALM;
  if (configKeycloakRealm !== "__KEYCLOAK_REALM__") {
    keycloakRealm = configKeycloakRealm;
  }

  const configKeycloakClientId = window.APP_CONFIG.KEYCLOAK_CLIENT_ID;
  if (configKeycloakClientId !== "__KEYCLOAK_CLIENT_ID__") {
    keycloakClientId = configKeycloakClientId;
  }
}


// Keycloak configuration
const keycloak = new Keycloak({
      url: keycloakUrl,
      realm: keycloakRealm,
      clientId: keycloakClientId,
});

// Флаг для отслеживания инициализации
let isInitializing = false;
let isInitialized = false;

// Initialize Keycloak
export const initKeycloak = (onAuthenticatedCallback) => {
  // Если уже инициализирован, просто вызываем callback
  if (isInitialized) {
    console.log("Keycloak already initialized, skipping...");
    onAuthenticatedCallback();
    return;
  }

  // Если идет процесс инициализации, ждем его завершения
  if (isInitializing) {
    console.log("Keycloak initialization in progress, waiting...");
    return;
  }

  isInitializing = true;
  
  console.log("Initializing Keycloak...");
  console.log("Keycloak URL:", keycloak.authServerUrl);
  console.log("Realm:", keycloak.realm);
  console.log("Client ID:", keycloak.clientId);

  keycloak
    .init({})
    .then((authenticated) => {
      isInitialized = true;
      isInitializing = false;
      
      console.log("Keycloak initialized successfully");
      console.log("Authenticated:", authenticated);
      
      if (authenticated) {
        console.log("✅ User is authenticated");
        console.log("Token:", keycloak.token?.substring(0, 50) + "...");
        console.log("Token parsed:", keycloak.tokenParsed);
      } else {
        console.log("❌ User is not authenticated");
      }
      onAuthenticatedCallback();
    })
    .catch((error) => {
      isInitializing = false;
      isInitialized = true;
      
      console.error("❌ Keycloak initialization error:", error);
      console.error("Error details:", error.message);
      
      // Викликаємо callback навіть при помилці
      onAuthenticatedCallback();
    });
};

// Login function
export const doLogin = () => keycloak.login();

// Logout function
export const doLogout = () => keycloak.logout();

// Get token
export const getToken = () => keycloak.token;

// Get refresh token
export const getRefreshToken = () => keycloak.refreshToken;

// Update token if needed
export const updateToken = (minValidity = 5) => {
  return keycloak.updateToken(minValidity).then((refreshed) => {
    if (refreshed) {
      console.log("Token refreshed");
    }
    return keycloak.token;
  }).catch(() => {
    console.log("Failed to refresh token");
    doLogout();
  });
};

// Check if user is authenticated
export const isAuthenticated = () => !!keycloak.authenticated;

// Get user info
export const getUsername = () => keycloak.tokenParsed?.preferred_username;

export default keycloak;